module.exports = __webpack_public_path__ + "img/enlarge.e858cd4e.svg";